import type { BoardMarkerPillProps, BoardMarkerPillWidthArgs } from "./types";

const HEIGHT = 1.5;
const CHAR_WIDTH = 0.62;
const PADDING = 1;

export const boardMarkerPillWidth = ({
  label,
  size,
}: BoardMarkerPillWidthArgs): number =>
  Math.max(size * HEIGHT, size * (label.length * CHAR_WIDTH + PADDING));

export const BoardMarkerPill = ({
  x,
  y,
  label,
  size,
  fillColor,
  strokeColor,
  opacity,
  isHighlighted = false,
}: BoardMarkerPillProps) => {
  const height = size * HEIGHT;
  const width = boardMarkerPillWidth({ label, size });
  const halo = size * 0.6;

  return (
    <g opacity={isHighlighted ? 1 : opacity} pointerEvents="none">
      {isHighlighted && (
        <rect
          data-testid="board-marker-halo"
          x={x - width / 2 - halo}
          y={y - height / 2 - halo}
          width={width + halo * 2}
          height={height + halo * 2}
          rx={height / 2 + halo}
          fill={fillColor}
          fillOpacity={0.25}
          stroke={strokeColor}
          strokeWidth={2}
          vectorEffect="non-scaling-stroke"
        >
          {/* Three beats, then it rests as a halo: nothing loops in a tool used all day. */}
          <animate
            attributeName="fill-opacity"
            values="0.55;0.1;0.55"
            dur="1.1s"
            repeatCount="3"
          />
        </rect>
      )}
      <rect
        x={x - width / 2}
        y={y - height / 2}
        width={width}
        height={height}
        rx={height / 2}
        fill={fillColor}
        stroke="#ffffff"
        strokeWidth={3}
        vectorEffect="non-scaling-stroke"
      />
      <rect
        x={x - width / 2}
        y={y - height / 2}
        width={width}
        height={height}
        rx={height / 2}
        fill="none"
        stroke={strokeColor}
        strokeWidth={1.25}
        vectorEffect="non-scaling-stroke"
      />
      <text
        x={x}
        y={y}
        fill={strokeColor}
        fontSize={size * 0.95}
        fontWeight={700}
        fontFamily="Arial"
        textAnchor="middle"
        dominantBaseline="central"
      >
        {label}
      </text>
    </g>
  );
};
